export default __webpack_public_path__ + "static/media/81.f9c3611e.jpeg";